import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

export const getSectionLabelSx = (theme: Theme) => ({
  fontWeight: 600,
  fontSize: '0.6875rem',
  color: alpha(theme.palette.text.primary, 0.5),
  textTransform: 'uppercase' as const,
  letterSpacing: '0.06em',
  mb: 0.75,
  display: 'block',
});

export const getInputRootSx = (theme: Theme) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: alpha(theme.table.stripeBg, 0.7),
    fontSize: '0.8125rem',
    transition: 'all 0.2s ease',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover': {
      backgroundColor: theme.table.stripeBg,
      '& fieldset': { borderColor: alpha(theme.border.color, 0.6) },
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.15)}`,
      '& fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },
    },
  },
});
